import { Box, Typography, MenuItem } from "@mui/material";
import React from "react"

type OuterMenuItemTypes = {
    criteria: boolean;
    openSubMenu?: boolean;
    text: string;
    onClick: (e: any) => void;
    icon: JSX.Element;
    optionalIcon?: JSX.Element;
    index: number;
}

export const OuterMenuItem: React.FC<OuterMenuItemTypes> = ({
    text,
    criteria,
    openSubMenu,
    icon,
    onClick,
    optionalIcon,
    index
}) => {
    return (
        <MenuItem
            onClick={onClick}
            style={index == 1 ? {
                borderBottom: "1px solid #0000001A",
                borderTop: "1px solid #0000001A",
                display: "flex",
                justifyContent: "space-between",
                position: "relative"
            } : { borderTop: "1px solid #0000001A",
                borderBottom: "1px solid #0000001A", }}
            sx={{
                backgroundColor: openSubMenu ? "#E9EFF4" : "",
                color: openSubMenu ? "#22638D" : "#595959",
                ':hover': {
                    backgroundColor: "#E9EFF4",
                    color: "#22638D"
                }
            }}
            disabled={criteria}
        >
            <Box display="flex">
                {icon}
                <Typography
                    marginLeft={1}
                >
                    {text}
                </Typography>
            </Box>
            {optionalIcon != undefined && (
                <>
                    {optionalIcon}
                </>
            )}
        </MenuItem>
    )
}